import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationInfo } from '@models/shared/pagination-info.model';

@Component({
  selector: 'app-pagination',
  imports: [TranslateModule],
  templateUrl: './pagination.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'block' },
})
export class PaginationComponent {
  readonly pagination = input.required<PaginationInfo>();
  readonly disabled = input(false);

  readonly pageChange = output<number>();

  protected readonly totalPages = computed(() => {
    const { total, limit } = this.pagination();
    return Math.max(1, Math.ceil(total / limit));
  });
  protected readonly hasPrevious = computed(() => this.pagination().page > 1);

  previous(): void {
    this.pageChange.emit(this.pagination().page - 1);
  }

  next(): void {
    this.pageChange.emit(this.pagination().page + 1);
  }
}
